<template>
  <div class="sidebar">
    <el-menu
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      mode="vertical"
      class="el-menu-demo"
      background-color="#333b4d"
      :unique-opened="true"
      text-color="#fff"
      active-text-color="#fff"
      router
    >
      <template v-for="(item,index) in routes" v-if="!item.hidden">
        <!-- 一级菜单 -->
        <el-menu-item v-if="!item.children" :index="item.path">
          <i :class="['iconfont',item.meta.icon]"></i>
          <span slot="title">{{item.meta.title}}</span>
        </el-menu-item>
        <!-- 二级菜单 -->
        <el-submenu :index="index+''" v-if="item.children">
          <template slot="title">
            <i :class="['iconfont',item.meta.icon]"></i>
            <span>{{item.meta.title}}</span>
          </template>
          <el-menu-item
            v-for="child in item.children"
            :index="child.path"
            v-if="!child.hidden"
            :key="child.path"
          >
            <i :class="['iconfont',child.meta.icon]"></i>
            <span>{{child.meta.title}}</span>
          </el-menu-item>
        </el-submenu>
        <!-- 三级菜单 -->
        <!-- <el-submenu :index="index+''" v-if="!item.leaf && item.leafThree">
          <template slot="title">
            <i :class="item.meta.icon"></i>
            <span>{{item.name}}</span>
          </template>

          <el-submenu
            v-for="child in item.children"
            :index="child.path"
            :key="child.path"
            v-if="child.leaf"
          >
            <template slot="title">
              <i :class="child.meta.icon"></i>
              <span>{{child.name}}</span>
            </template>
            <el-menu-item
              v-for="childThree in child.children"
              :index="childThree.path"
              :key="childThree.path"
            >
              <i :class="childThree.meta.icon"></i>
              <span>{{childThree.name}}</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item
            v-for="child in item.children"
            :index="child.path"
            v-if="!child.hidden && !child.leaf"
            :key="child.path"
          >
            <i :class="child.meta.icon"></i>
            <span>{{child.name}}</span>
          </el-menu-item>
        </el-submenu>-->
      </template>
    </el-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    routes() {
      return this.$router.options.routes;
    },
    isCollapse() {
      return;
    }
  }
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>


// WEBPACK FOOTER //
// src/components/sidebar/index.vue